import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
	tpVastConfigClass: {
		height: '60%',
		margin: '0 4rem'
	},
	buttonClass: {
		width: '50%'
	}
}));
